import { Navigation } from "@/layouts/AppPage/components/Navigation";
import {
  FlexNoPaddingContentWrapper,
  FlexPageContentWrapper,
  IntroText,
  PageContentWrapper,
  Title,
} from "@/layouts/AppPage/styles";
import { AppPageProps, BaseAppPageProps } from "@/layouts/AppPage/types";

export const AppPage: React.FC<BaseAppPageProps> = ({
  children,
  introText,
  showNavigation,
  title,
  PageContentWrapper,
}) => (
  <>
    {showNavigation && <Navigation />}

    <PageContentWrapper>
      {title && <Title>{title}</Title>}
      {introText && <IntroText>{introText}</IntroText>}

      {children}
    </PageContentWrapper>
  </>
);

AppPage.defaultProps = {
  showNavigation: true,
};

// +-----------------+
// | Implementations |
// +-----------------+

export const DefaultAppPage: React.FC<AppPageProps> = (props) => (
  <AppPage {...props} PageContentWrapper={PageContentWrapper} />
);

export const AppPageNoMaxWidth: React.FC<AppPageProps> = (props) => (
  <AppPage {...props} PageContentWrapper={FlexPageContentWrapper} />
);

export const AppPageNoTopPadding: React.FC<AppPageProps> = (props) => (
  <AppPage {...props} PageContentWrapper={FlexNoPaddingContentWrapper} />
);
